export const RemoteTypes = {
    CICD: 'CICD',
    GIT: 'GIT',
    URL: 'URL',
};
// TODO: Use types from DB or API client to avoid code duplication and keep in sync
export const GitProviderType = {
    GITHUB_CLOUD: 'GITHUB_CLOUD',
    GITHUB_SERVER: 'GITHUB_SERVER',
    GITLAB_CLOUD: 'GITLAB_CLOUD',
    GITLAB_SELF_MANAGED: 'GITLAB_SELF_MANAGED',
    BITBUCKET_CLOUD: 'BITBUCKET_CLOUD',
    BITBUCKET_DATACENTER: 'BITBUCKET_DATACENTER',
    AZURE_DEVOPS_SERVICES: 'AZURE_DEVOPS_SERVICES',
};
//# sourceMappingURL=remotes.js.map